<template>
	<div class="rootDiv">
		<div class="retrieve">
			<div class="searchDiv flex flex-jb">
				<div></div>
				<div class="flex flex-ac">
					<div class="fs-16 fc-6b9eff pointer" @click="addList">
						<i class="el-icon-circle-plus-outline mr-10 fs-18"></i>新增
					</div>
				</div>
			</div>
		</div>
		<div class="tableDiv pall-30">
<!-- 			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="一番赏" name="5"> -->
					<TableHeightFull>
						<EleTable ref="tableRef" slot="table" :tableData="tableData" key="table1" :columns="columns" height="100%" :border="false" v-loading="tabLoading"
							:row-style="{ cursor: 'pointer' }">
							<template v-slot:img="scope">
								<img :src="scope.row.img" alt="" class="smallImg">
							</template>
						</EleTable>
						<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
					</TableHeightFull>
				<!-- </el-tab-pane> -->
<!-- 				<el-tab-pane label="福袋" name="10">
					<TableHeightFull>
						<EleTable ref="tableRef" slot="table" :tableData="tableData" key="table2" :columns="columns" height="100%" :border="false" v-loading="tabLoading"
							:row-style="{ cursor: 'pointer' }">
							<template v-slot:img="scope">
								<img :src="scope.row.img" alt="" class="smallImg">
							</template>
						</EleTable>
						<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
					</TableHeightFull>
				</el-tab-pane> -->
			<!-- </el-tabs> -->
		</div>
		<!-- 弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" top="10vh" width="30%" @close="resetForm">
			<el-form :model="ruleForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
				<el-form-item label="抽数" prop="buyNum" v-if="'buyNum' in ruleForm" :rules="{required: true, message: '抽数不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.buyNum"></el-input>
				</el-form-item>
				<el-form-item label="最大立减(大)" prop="highMax" v-if="'highMax' in ruleForm" :rules="{required: true, message: '最大区间立减(大)不能为空', trigger: 'blur'}">
					<el-input type="text" v-model="ruleForm.highMax"></el-input>
				</el-form-item>
				<el-form-item label="最大立减(小)" prop="highMin" v-if="'highMin' in ruleForm" :rules="{required: true, message: '最大区间立减(小)不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.highMin"></el-input>
				</el-form-item>
				<el-form-item label="最大区间概率" prop="highProb" v-if="'highProb' in ruleForm" :rules="{required: true, message: '最大区间概率不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.highProb"></el-input>
				</el-form-item>
				<el-form-item label="最小立减(大)" prop="lowMax" v-if="'lowMax' in ruleForm" :rules="{required: true, message: '最小区间立减(大)不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.lowMax"></el-input>
				</el-form-item>
				<el-form-item label="最小立减(小)" prop="lowMin" v-if="'lowMin' in ruleForm" :rules="{required: true, message: '最小区间立减(小)不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.lowMin"></el-input>
				</el-form-item>
				<el-form-item label="最小立减概率" prop="lowProb" v-if="'lowProb' in ruleForm" :rules="{required: true, message: '最小区间立减概率(小)不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="ruleForm.lowProb"></el-input>
				</el-form-item>
				<el-form-item label="启用状态" prop="status" v-if="'status' in ruleForm" :rules="{required: true, message: '请选择启用状态', trigger: 'change'}">
					<el-select v-model="ruleForm.status" placeholder="请选择" class="my-select">
						<el-option v-for="item in statusList" :key="item.value" :label="item.key" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="affirmPopup" :loading="butLoading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import indexMixin from "@/utils/indexMixin"
	export default {
		name: 'disCount',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve)
		},
		data() {
			return {
				tabLoading: false,
				butLoading: false,
				activeName: '5',
				tableData: [],
				dialogFormVisible: false,
				dialogTitle: '新增',
				statusList: [{
					key: '启用',
					value: 1
				}, {
					key: '禁用',
					value: 0
				}],
				ruleForm: {
					fee: '', //实付款
					highMax: '', //大额区间最大值
					highMin: '', //大额区间最小值
					highProb: '', //大额区间概率(0.2代表20%)
					lowMax: '', //小额区间最大值
					lowMin: '', //小额区间最小值
					lowProb: '', //小额区间概率(0.8代表80%)
					status: 1, //使用门槛
					// goodsType: ''
				},
				columns: [{
					type: 'index',
					label: '序号',
					width: '60',
					align: 'center',
					fixed: 'left'
				}, {
					label: '实付款',
					prop: 'fee',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最大区间立减(大)',
					prop: 'highMax',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最大区间立减(小)',
					prop: 'highMin',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最大区间概率',
					prop: 'highProb',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最小区间立减(大)',
					prop: 'lowMax',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最小区间立减(小)',
					prop: 'lowMin',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '最小区间立减概率',
					prop: 'lowProb',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '是否禁用',
					prop: 'status',
					align: 'left',
					'show-overflow-tooltip': true,
					formatData: (ele) => {
						return ele == 1 ? '启用' : '禁用'
					}
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					fixed: 'right',
					width: '210',
					buttons: [{
						type: 'text',
						text: '编辑',
						fn: this.editList
					}, {
						type: 'text',
						text: '删除',
						fn: this.deleteList
					}, ],
				}, ]
			}
		},
		mounted() {
			this.getTableData()
		},
		methods: {
			//跳转详情
			headerRowClick(row) {
				console.log(row)
			},
			//新增列表
			addList() {
				this.dialogTitle = "新增"
				this.ruleForm = {
					fee: '', //抽数
					highMax: '', //大额区间最大值
					highMin: '', //大额区间最小值
					highProb: '', //大额区间概率(0.2代表20%)
					lowMax: '', //小额区间最大值
					lowMin: '', //小额区间最小值
					lowProb: '', //小额区间概率(0.8代表80%)
					status: 1, //使用门槛
					// goodsType: this.activeName
				}
				this.dialogFormVisible = true
			},
			handleClick() {
				this.tableData = ''
				this.getTableData()
			},
			getTableData() {
				this.tabLoading = true
				this.$http.get('/promoRandomReduceConfig/list').then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data
					this.pageInfo.total = result.data.length
				}).catch(err => {
					this.tabLoading = false
				})
			},
			//编辑列表
			editList(row) {
				this.dialogTitle = "编辑"
				this.ruleForm = JSON.parse(JSON.stringify(row))
				this.dialogFormVisible = true
			},
			//删除
			deleteList(row) {
				this.$confirm('您确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/promoRandomReduceConfig/delete', {
						id: row.id
					}).then(res => {
						this.getTableData()
						this.$message({
							message: '删除成功',
							type: 'success'
						})
					})
				})
			},
			//确认弹框
			affirmPopup() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.butLoading = true
						let apiUrl = ""
						if (this.dialogTitle == '新增') {
							apiUrl = "/promoRandomReduceConfig/add"
						} else if (this.dialogTitle == '编辑') {
							apiUrl = "/promoRandomReduceConfig/update"
						}
						let ruleForm = JSON.stringify(this.ruleForm)
						this.$http.post(apiUrl, ruleForm, {
							headers: {
								'Content-Type': 'application/json'
							}
						}).then(({
							data: result
						}) => {
							this.$message({
								message: this.dialogTitle + '成功',
								type: 'success'
							})
							this.getTableData()
							this.butLoading = false
							this.dialogFormVisible = false
						}).catch(err => {
							this.butLoading = false
						})
					}
				})
			},
			//重置清除校验
			resetForm() {
				Object.assign(this.$data.ruleForm, this.$options.data().ruleForm)
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate()
				})
			},
		}
	}
</script>
<style>
</style>